export const TEXTS = {
  TITLE: 'Тариф видеовещания',
  ROW1_TITLE: '1 - 9 экранов',
  ROW2_TITLE: '10 - 29 экранов',
  ROW3_TITLE: 'от 30 экранов',

  ROW1_MONTH_PRICE: '990 ₽',
  ROW2_MONTH_PRICE: '890 ₽',
  ROW3_MONTH_PRICE: '690 ₽',

  ROW1_YEAR_PRICE: '10 890 ₽',
  ROW2_YEAR_PRICE: '9 790 ₽',
  ROW3_YEAR_PRICE: '7 590 ₽',

  MONTH_TITLE: '/ мес за 1 экран',
  YEAR_TITLE: '/ год за 1 экран',

  VIDEO_PRICE_INFO_DESCRIPTION_1: 'Видеовещание — платная услуга.',
  VIDEO_PRICE_INFO_DESCRIPTION_2: 'Для подключения отправьте запрос.',
};
